import React from 'react';
import { ApplicationView } from '@aha-app/mvc';
import Tool, { type ToolButtonComponent } from './Tool';
import ToolButton from '../toolbars/ToolButton';
import { svgToIcon } from '../utils/svg';
import addColumnIcon from '../assets/icons/addColumn.svg';
import { isTable } from '../objects/guards';

class ToolAddColumnLeft extends Tool {
  static toolName = 'Insert column left';

  static action({ controller, selection }) {
    selection.addVector && selection.addVectorOnClick(true, false);
    Tool.toolActionComplete({ controller });
  }
}

class ToolAddColumnRight extends Tool {
  static toolName = 'Insert column right';

  static action({ controller, selection }) {
    selection.addVector && selection.addVectorOnClick(false, false);
    Tool.toolActionComplete({ controller });
  }
}

const AddColumnButton: ToolButtonComponent = ApplicationView(
  ({ controller, selection, tool }) => {
    return (
      <span>
        <ToolButton
          onClick={() => {
            if (isTable(selection)) {
              selection.addVectorToEnd(false);
            }

            tool.toolActionComplete({ controller });
          }}
          tool={tool}
        >
          {svgToIcon(addColumnIcon)}
        </ToolButton>
      </span>
    );
  }
);

class ToolAddColumn extends Tool {
  static toolName = 'Add column';

  static buttonComponent() {
    return AddColumnButton;
  }
}

export { ToolAddColumn, ToolAddColumnLeft, ToolAddColumnRight };
